import React, {PureComponent, ChangeEvent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {T} from 'helpers/i18n'
import {BackgroundImage} from 'elements'

interface Props {
  name: string
  column?: string
  value: string
  footer?: string
  accept?: string

  onChange(name: string, value: File, column?: string): void
}

interface State {
  image: string | ArrayBuffer | null
}

class InputImage extends PureComponent<Props, State> {
  state: State = {
    image: this.props.value
  }

  handleImage = (event: ChangeEvent<HTMLInputElement>) => {
    console.log('FieldImage - handleImage')
    if (event.target.files && event.target.files.length > 0) {
      console.log('FieldImage - handleImage - if')
      event.persist()
      const file = event.target.files[0]
      const accept = this.props.accept || 'image/jpeg'
      console.log('FieldImag - handleImage - if - accept: ', accept)
      console.log('FieldImag - handleImage - if - file.type: ', file.type)
      if (file.type === accept) {
        this.props.onChange(this.props.name, file, this.props.column)
        const fileReader = new FileReader()
        fileReader.onload = () => {
          this.setState({image: fileReader.result as string}) // as string porque uso readAsDataURL
        }
        fileReader.readAsDataURL(file)
      } else {
        console.log('FieldImage - handleImage - if - else')
      }
    } else {

    }
  }

  render() {
    console.log('FieldImage - render')
    const {name, footer, accept} = this.props
    const {image} = this.state!
    return (
      <Wrapper>
        <Label>{T(name)}</Label>
        <BackgroundImage image={image}>
          <StyledInput
            type="file"
            accept={accept? accept : 'image/jpeg'}
            onChange={this.handleImage}
          />
        </BackgroundImage>
        <StyledText>{footer? footer : T('imageProperties')}</StyledText>
      </Wrapper>
    )
  }
}

export default InputImage

const Wrapper = cxs('div')({
  maxWidth: '60%',
  margin: 'auto',
  [mediaQueries.desktop]: {
    maxWidth: Theme.common.size.maxWidth / 3 + 'px'
  } as CSSProperties
} as CSSProperties)

const Label = cxs('p')({
  color: Theme.color.placeholder,
  textAlign: 'center'
} as CSSProperties)

const StyledInput = cxs('input')({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  opacity: 0,
  cursor: 'pointer'
} as CSSProperties)

const StyledText = cxs('div')({
  textTransform: 'none',
  textAlign: 'center',
  fontSize: Theme.fontSize.small,
  color: Theme.color.placeholder,
  padding: `${Theme.size.space[1]} 0 ${Theme.size.space[2]}`
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/FieldImage.tsx